import { render, staticRenderFns } from "./singleExclusive.vue?vue&type=template&id=80e5d736&scoped=true&"
import script from "./singleExclusive.vue?vue&type=script&lang=js&"
export * from "./singleExclusive.vue?vue&type=script&lang=js&"
import style0 from "./singleExclusive.vue?vue&type=style&index=0&id=80e5d736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e5d736",
  null
  
)

component.options.__file = "singleExclusive.vue"
export default component.exports